// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"366eb8a2","200":"c23aa576","612":"23552c52","855":"d0e7b94b","938":"b5817263","950":"30ff6622","982":"0168ef0a"}[chunkId] + ".chunk.js";
};